import { useEffect } from "react";
import Hero from "../components/Hero";
import ContactForm from "../components/ContactForm";
import Team from "../components/Team";
import cntctImg from "../assets/img/banners/contacto.png";

export default function Contacto() {
  useEffect(() => {
    document.title = "ProMedic - Contacto y Equipo";
  }, []);

  return (
    <>
      <Hero img={cntctImg} position="relative" />
      <div className="grid md:grid-cols-2 mt-[22vh] md:mt-[34%] mx-auto w-9/12">
        <div className="md:border-r-2 md:p-5">
          <h3 className="font-bold text-black text-4xl mb-2">
            Queremos conocerte
          </h3>
          <p>
            Cuéntanos sobre tu proyecto y trabajemos juntos tus objetivos.
            <br />
            <br />
            Rellena el formulario y nuestro equipo estará en contacto contigo.
          </p>
        </div>
        <ContactForm />
      </div>
      <Team />
    </>
  );
}
